import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';

@Injectable()
export class MatPaginatorIntlFr extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Éléments par page';
  override nextPageLabel = 'Page suivante';
  override previousPageLabel = 'Page précédente';
  override firstPageLabel = 'Première page';
  override lastPageLabel = 'Dernière page';

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    const total = Math.max(length, 0);
    if (total === 0 || pageSize === 0) {
      return `0 à ${total}`;
    }

    const debut = page * pageSize;
    const fin = debut < total ? Math.min(debut + pageSize, total) : debut + pageSize;

    return `${debut + 1} à ${fin} (${total} au total)`;
  };
}
